import { RECEIVE_SAVED_ITEMS_MAP } from '../constants/saved-items';
import { LOGIN_SUCCESS, LOGOUT_SUCCESS } from '../constants/auth';
import { UPDATE_COMMUNICATION_PREFS_SUCCESS } from '../constants/communication-prefs';
import { UPDATE_PERSONAL_DETAILS_SUCCESS } from '../constants/personal-details';
import { showSnackbar, hideSnackbar } from '../actions/snackbar';

/**
 * Middleware for showing snackbars based on action types.
 * @returns {Function}
 */
export default function snackbarMiddleware() {
  return ({ dispatch, getState }) => next => action => {
    const result = next(action);

    switch (action.type) {
      // Clear snackbar on first responsive calculation
      case 'redux-responsive/CALCULATE_RESPONSIVE_STATE':
        dispatch(hideSnackbar());
        break;

      case LOGIN_SUCCESS:
        dispatch(showSnackbar('Logged in successfully'));
        break;

      case LOGOUT_SUCCESS:
        dispatch(showSnackbar('You have been logged out'));
        break;

      case RECEIVE_SAVED_ITEMS_MAP:
        if (
          action.meta?.source === 'saved-items' &&
          action.meta?.actionType === 'add'
        ) {
          dispatch(showSnackbar('Style saved to favourites', 'success'));
        }
        if (
          action.meta?.source === 'saved-items' &&
          action.meta?.actionType === 'delete'
        ) {
          dispatch(showSnackbar('Style removed from favourites', 'success'));
        }
        break;

      case UPDATE_COMMUNICATION_PREFS_SUCCESS: {
        const msg = getState().communicationPrefsForm?.confirmationMessage;
        if (msg) {
          dispatch(showSnackbar(msg, 'success'));
        }
        break;
      }

      case UPDATE_PERSONAL_DETAILS_SUCCESS: {
        const msg = getState().personalDetailsForm?.confirmationMessage;
        if (msg) {
          dispatch(showSnackbar(msg, 'success'));
        }
        break;
      }

      default:
        break;
    }

    return result;
  };
}
